<div fxLayoutAlign.gt-md="space-between center">
  <div>
    <h1>
      Documentos Complementares - Inscrição #{{ inscricaoId }} - {{ nomeInscricao }}
      <p *ngIf="nomeSocialInscricao" class="nome-social">Nome Social: {{ nomeSocialInscricao }}</p>
    </h1>
  </div>
  <div fxLayout="row" fxLayoutAlign="end start">
    <app-back-button (back)="voltar()"></app-back-button>
  </div>
</div>

<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <fieldset fxFlex="100%" *ngIf="mapGruposComplementos.size > 0">
      <legend>Informações Complementares</legend>
      <inscricoes-input-nota-avaliacao *ngIf="idConcurso"
        [notaInicial]="nota"
        [disabled]="envelopeEnviado"
        [peso]="pesoProva"
        [descricaoProva]="descricaoProva"
        (confirmarNota)="onNotaConfirmation($event)" />
      <div *ngFor="let g of mapGruposComplementos | keyvalue : asIsOrder" class="complements-group">
        <h3>{{ g.key }}</h3>
        <div *ngFor="let complemento of g.value" class="complemento-item">
          <div class="complemento-header">
            <strong>{{ complemento.explicacao }}</strong>
            <span class="complemento-tipo">{{ getTipoComplementoDescricao(complemento.tipoComplemento) }}</span>
            <span *ngIf="complemento.requerido" class="obrigatorio">(Obrigatório)</span>
            <span *ngIf="!complemento.requerido" class="opcional">(Opcional)</span>
          </div>
          <div class="complemento-valor" *ngIf="complemento.valor">
            <div *ngIf="complemento.tipoComplemento === 'FILE'">
              <button
                mat-icon-button
                color="primary"
                (click)="visualizarDocumento(complemento)"
                [disabled]="isDownloading(complemento)"
                matTooltip="Visualizar documento">
                <mat-icon *ngIf="!isDownloading(complemento)">visibility</mat-icon>
                <mat-spinner *ngIf="isDownloading(complemento)" diameter="20"></mat-spinner>
              </button>
              <div *ngIf="isDownloading(complemento)" class="progress-container">
                <mat-progress-bar mode="determinate" [value]="getDownloadProgress(complemento)"></mat-progress-bar>
                <span class="progress-text">{{ getDownloadProgress(complemento) }}%</span>
              </div>
            </div>
            <div *ngIf="complemento.tipoComplemento !== 'FILE'">
              {{ complemento.valor }}
            </div>
          </div>
          <div *ngIf="!complemento.valor" class="sem-valor">
            <span>Não informado</span>
          </div>
        </div>
      </div>
    </fieldset>

    <div *ngIf="mapGruposComplementos.size === 0" class="sem-complementos">
      <mat-icon>folder_open</mat-icon>
      <p>Nenhum documento complementar encontrado para esta inscrição.</p>
    </div>
  </mat-card-content>
</mat-card>
